<template>
  <header-modal id="message-modal" class="fade">
    <h5 slot="header" class="modal-title" id="modalLabel">
      <i class="fa fa-info-circle" aria-hidden="false"></i>
    </h5>
    <slot></slot>
    <button slot="footer" type="button" class="btn btn-info" data-dismiss="modal">OK</button>
  </header-modal>
</template>

<script>
import HeaderModal from 'components/HeaderModal'
import $ from 'jquery'
export default {
  components: {
    HeaderModal
  },
  methods: {
    showModal () {
      $('#message-modal').modal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// MessageModal.vue?e038a4c0